import React, { ReactNode } from 'react'
import { ConfigProvider, theme } from 'antd'
import zhTW from 'antd/locale/zh_TW'
import zhCN from 'antd/locale/zh_CN'
import enUS from 'antd/locale/en_US'
import jaJP from 'antd/locale/ja_JP'
import { useLanguage } from '../../contexts/LanguageContext'

const darkTheme = {
  algorithm: theme.darkAlgorithm,
  token: {
    colorPrimary: '#3742fa',
    colorSuccess: '#00d4aa',
    colorError: '#ff4757',
    colorWarning: '#ffa502',
    colorBgBase: '#0a0e1a',
    colorBgContainer: '#1a1f2e',
    colorBorder: '#2a2f3e',
    colorText: '#ffffff',
    colorTextSecondary: '#a0a6b8',
  },
}

interface AntdProviderProps {
  children: ReactNode
}

const AntdProvider: React.FC<AntdProviderProps> = ({ children }) => {
  const { language } = useLanguage()

  const locale =
    language === 'zh-TW' ? zhTW :
    language === 'zh' ? zhCN :
    language === 'ja' ? jaJP :
    enUS

  return (
    <ConfigProvider theme={darkTheme} locale={locale}>
      {children}
    </ConfigProvider>
  )
}

export default AntdProvider
